/** @format */

import { Component, OnInit } from "@angular/core";
import * as alertify from "alertifyjs";
import { Location } from "@angular/common";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ApiServiceService } from "src/app/Services/api-service.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { WarningDialogComponent } from "src/app/Shared/shared/warning-dialog/warning-dialog.component";

@Component({
	selector: "app-print-receipt",
	templateUrl: "./print-receipt.component.html",
	styleUrls: ["./print-receipt.component.css"],
})
export class PrintReceiptComponent implements OnInit {
	isEmpty: boolean = false;
	page: number = 0;
	num: number = 1;
	currentPage: number = 1;
	details: any;
	isLoading: any;
	isSearching: any;
	count: number = 0;
	pageSize: number = 5;
	searchForm: any = FormGroup;
	showSearch: boolean = false;
	currentCategory: any;
	currentRevenueType: any;
	mdaCodeList: any[];
	tempRevenueType: string;
	countDetails: any;
	searchInstruction: boolean;
	showDropdown: boolean;

	constructor(
		private location: Location,
		private fb: FormBuilder,
		private apiService: ApiServiceService,
		private bsModalService: BsModalService,
	) {}
	ngOnInit(): void {
		this.searchForm = this.fb.group({
			asinExternal: [""],
			rrr: [""],
			offset: [""],
		});

		this.searchInstruction = true;
	}

	confirmIfTimeIsSelected() {
		this.showDropdown = false;

		if (
			!this.searchForm.get("from").value ||
			!this.searchForm.get("to").value
		) {
			this.showDropdown = false;

			this.warningModal(
				"The 'From' and 'To' dates are required for downloads, with a maximum interval of 90 days.",
			);
		}

		if (
			this.searchForm.get("from").value &&
			this.searchForm.get("to").value
		) {
			const fromDate = new Date(this.searchForm.get("from").value);
			const toDate = new Date(this.searchForm.get("to").value);

			const differenceInDays = Math.floor(
				(toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24),
			);

			if (differenceInDays < 91) {
				this.showDropdown = true;
			} else {
				this.warningModal("The date range should not exceed 90 days.");
				this.showDropdown = false;
			}
		}
	}

	warningModal(message: any) {
		let dfModalRef = this.bsModalService.show(WarningDialogComponent, {
			initialState: {
				body: message,
			},
			class: "modal-sm modal-dialog-centered",
		});
		dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
			dfModalRef.hide();
		});
	}

	downloadPDF() {
		let url = "/assessments/search-payments/download-pdf";

		let formData = {
			revenueType: this.tempRevenueType,
			mdaRecordId: this.searchForm.get("mdaRecordId").value,
			feeDescription: this.searchForm.get("feeDescription").value,
			rrr: this.searchForm.get("rrr").value,
			from: this.searchForm.get("from").value,
			to: this.searchForm.get("to").value,
			paymentChannel: this.searchForm.get("paymentChannel").value,
			paymentStatus: this.searchForm.get("paymentStatus").value,
		};

		this.apiService.post(url, formData, { responseType: "blob" }).subscribe(
			(response: Blob) => {
				const blob = new Blob([response], { type: "application/pdf" });

				// Create a Blob URL for the PDF content
				const blobUrl = window.URL.createObjectURL(blob);

				// Open PDF in a new tab
				// window.open(blobUrl, '_blank');

				const file = new Blob([response], { type: "application/pdf" });

				const fileURL = URL.createObjectURL(file);
				window.open(fileURL);

				// Optionally, trigger a download by creating an anchor element
				const downloadLink = document.createElement("a");
				downloadLink.href = blobUrl;
				downloadLink.target = "_blank";
				downloadLink.download = "assessmentReport.pdf"; // File name for download

				// Uncomment this line to trigger the download automatically
				downloadLink.click();

				alertify.set("notifier", "position", "top-center");
				alertify.success("Download successful");
			},
			(error) => {
				this.isLoading = false;
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
			},
		);
	}

	toggleSearch() {
		this.showSearch = !this.showSearch;
	}

	downloadCSV() {
		let url = "/assessments/search-payments/download-csv";

		let formData = {
			revenueType: this.tempRevenueType,
			mdaRecordId: this.searchForm.get("mdaRecordId").value,
			feeDescription: this.searchForm.get("feeDescription").value,
			rrr: this.searchForm.get("rrr").value,
			from: this.searchForm.get("from").value,
			to: this.searchForm.get("to").value,
			paymentChannel: this.searchForm.get("paymentChannel").value,
			paymentStatus: this.searchForm.get("paymentStatus").value,
		};

		this.apiService
			.post(url, formData, {
				responseType: "blob", // Ensure responseType is set to 'blob'
			})
			.subscribe(
				(response: Blob) => {
					const blob = new Blob([response], { type: "text/csv" });

					// Create a Blob URL for the CSV content
					const blobUrl = window.URL.createObjectURL(blob);

					// Open the CSV file in a new tab
					window.open(blobUrl);

					alertify.set("notifier", "position", "top-center");
					alertify.success("Download successful");
				},
				(error) => {
					// Handle error cases
					console.error(
						"Error occurred while downloading CSV:",
						error,
					);
					alertify.set("notifier", "position", "top-center");
					alertify.error("Error performing this operation");
				},
			);
	}

	downloadExcel() {
		let url = "/assessments/search-payments/download-excel";

		let formData = {
			revenueType: this.tempRevenueType,
			mdaRecordId: this.searchForm.get("mdaRecordId").value,
			feeDescription: this.searchForm.get("feeDescription").value,
			rrr: this.searchForm.get("rrr").value,
			from: this.searchForm.get("from").value,
			to: this.searchForm.get("to").value,
			paymentChannel: this.searchForm.get("paymentChannel").value,
			paymentStatus: this.searchForm.get("paymentStatus").value,
		};

		this.apiService
			.post(url, formData, {
				responseType: "blob", // Ensure responseType is set to 'blob'
			})
			.subscribe(
				(response: Blob) => {
					// No need to create a new Blob here, as the response is already a Blob
					const blobUrl = window.URL.createObjectURL(response);

					window.open(blobUrl);

					alertify.set("notifier", "position", "top-center");
					alertify.success("Download successful");
				},
				(error) => {
					// Handle error cases
					console.error(
						"Error occurred while downloading Excel:",
						error,
					);
					alertify.set("notifier", "position", "top-center");
					alertify.error("Error performing this operation");
				},
			);
	}

	resetForm() {
		this.searchForm = this.fb.group({
			asinExternal: [""],
			rrr: [""],
			offset: [""],
		});
	}

	callDb(event: any) {
		this.currentPage = event;

		this.page = event - 1;

		this.search();
	}

	search() {
		this.searchInstruction = false;

		this.details = [];
		this.countDetails = {};

		var formData: any = new FormData();
		this.isEmpty = false;
		this.isSearching = true;

		this.num = this.page * 5;
		const payload = {
			asin: this.searchForm.get("asinExternal").value,
			rrr: this.searchForm.get("rrr").value,
			offset: this.num,
		};

		const url = "/payment/v1/public/payment/search";

		this.apiService.post(url, payload).subscribe(
			(response) => {
				this.details = response?.results;
				if (this.details.length > 0) {
					this.isLoading = false;
					this.count = Math.ceil(response.total);
					this.isSearching = false;
				} else {
					this.isLoading = false;
					this.isSearching = false;
					this.isEmpty = true;
				}
			},
			(error) => {
				this.isLoading = false;
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
				this.isEmpty = true;
				this.isSearching = false;
			},
		);
	}

	getGamingTaxList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedGamingTax";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getMinistryList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedMinistry";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}
	getMarketList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedMarket";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getTransportList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedTransport";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getWhtList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedWht";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getPresumptiveTaxList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedPresumptiveTax";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getStampDutyList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedStampDuty";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getBusinessPremisesList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedBusinessPremises";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getFireServiceChargeList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedFireServiceCharge";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getDevelopmentLevyList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedDevelopmentLevy";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getWasteCollectionFeeList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedWasteCollectionFee";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getCapitalGainsTaxList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedCapitalGainsTax";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getDaList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedDa";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}

	getPayeList() {
		this.isLoading = true;
		const url = "/assessments/getSelectedPaye";

		this.apiService.suppressAlertError = true;
		this.apiService.get(url).subscribe(
			(response) => {
				if (response.success == true || response.status == "OK") {
					this.mdaCodeList = response.data;
					this.isLoading = false;
				} else {
					this.mdaCodeList = [];
					this.isLoading = false;
				}
			},
			(error) => {
				this.mdaCodeList;
				this.isLoading = false;
			},
		);
	}
	goBack() {
		this.location.back();
	}

	downloadPaymentReceipt(rrr: string) {
		let url = "/payment/v1/public/payment/receipt";

		let dto = {
			rrr: rrr,
		};

		this.apiService.post(url, dto, { responseType: "blob" }).subscribe(
			(response: Blob) => {
				const blob = new Blob([response], { type: "application/pdf" });

				// Create a Blob URL for the PDF content
				const blobUrl = window.URL.createObjectURL(blob);

				// Open PDF in a new tab
				// window.open(blobUrl, '_blank');

				const file = new Blob([response], { type: "application/pdf" });

				const fileURL = URL.createObjectURL(file);
				window.open(fileURL);

				// Optionally, trigger a download by creating an anchor element
				const downloadLink = document.createElement("a");
				downloadLink.href = blobUrl;
				downloadLink.target = "_blank";
				downloadLink.download = "payment_receipt.pdf"; // File name for download

				// Uncomment this line to trigger the download automatically
				downloadLink.click();

				alertify.set("notifier", "position", "top-center");
				alertify.success("Download successful");
			},
			(error) => {
				this.isLoading = false;
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
			},
		);
	}
}
